import { useProposalCopyingForRecalTracked } from "presentation/store/ProposalCopyingForRecal/ProposalCopyingForRecalProvider";
import { SliderPanel } from "veronica-ui-component/dist/component/core";
import CopyTariffItemTierEditPanel from "./CopyTariffItemTierEditPanel";
import RecalCopyPreviewPanel from "./RecalCopyPreviewPanel";

const ProposalCopyingForRecalEditRightPanel = () => {
    const [proposalCopyingForRecalState] = useProposalCopyingForRecalTracked();
    const { isShowCopyEditTierPanel } = proposalCopyingForRecalState;

    return <>
        <div className={`main-comp-wrapper${(isShowCopyEditTierPanel) ? '' : ' im-hide-side-form-draggable'}`}>
            <SliderPanel
                isOpen={true}
                draggable={false}
                leftSectionWidth={isShowCopyEditTierPanel ? "50%" : "100%"}
                rightSectionWidth={isShowCopyEditTierPanel ? "50%" : "0%"}
                leftChildren={<RecalCopyPreviewPanel />}
                rightChildren={<CopyTariffItemTierEditPanel />}
            />
        </div>
    </>
}

export default ProposalCopyingForRecalEditRightPanel;
